import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from "react-redux-toastr";
import {Loader} from "../Common/Loader";
import WordCloud from "../Common/WordCloud";
import {getTagCloudDetails} from "../../actions/DashboardAction";
import queryString from 'query-string';
import { langs } from '../../config/localization';
import DefaultWordCloud from "../WordCloud/DefaultWordCloud";

class TagCloud extends Component {

    componentWillMount(){
        const count = this.props.match.params.count;
        let params = queryString.parse(this.props.location.search);

        if(typeof params.uid !== 'undefined' && typeof params.authtoken !== 'undefined'){
           
            this.props.getTagCloudDetails(count, params.uid, params.authtoken, (response)=>{} );
        }else{

            toastr.error(langs.error, "Invalid Token");
            //Delay the page redirection for 3 second to show toastr message
            setTimeout(function () {
                window.location.assign('/home');
            }.bind(this), 3000);
        }

    }
    /**
     * Render dashboard
     * @returns {*}
     */
    render(){
        const tagCloudDetail = (this.props.tagCloudDetail)?this.props.tagCloudDetail:[];

        if(tagCloudDetail.length > 0) {
            return (
                <div>
                    <section className="dashboard-page">

                        <div className="row">
                            <div className="medium-12 columns">
                                <div className="tag-banner mobile-tag-cloud shadow-box m-t30">
                                    {/*<img src="assets/images/eathdeck/word-cloud-correction-small.png" />*/}
                                    {/*<WordCloud tagCloudDetail={tagCloudDetail} platform='mobile'/>*/}
                                    <DefaultWordCloud onClick={this.onTagsEventClick} tagCloudDetail={tagCloudDetail}
                                                      projectDetails={this.projectDetails} platform='mobile'/>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            );
        } else {
            return null;
        }
    }
}

//Connect action to component

//Map state to props
function mapStateToProps(state, localProps) {
    let returnObj = {};
    if(typeof state.dashboard.tagCloudDetail != 'undefined'){
        returnObj.tagCloudDetail = state.dashboard.tagCloudDetail;
    }
    return returnObj;
}
//Connect action to component
export default connect(mapStateToProps,
    {getTagCloudDetails}
)(TagCloud);


// WEBPACK FOOTER //
// ./components/Dashboard/TagCloud.js